import React from "react";
import { IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setTvMode } from "../booking-instruments/redux/actions";
import { OwcTooltip, OwcIcon } from "@one/react";

const TvModeToggle = ({ visible = true, disabled = false }) => {
  const dispatch = useDispatch();
  const isTvMode = useSelector((state) => state?.bookingInstruments?.isTvMode);

  if (!visible) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, opacity: disabled ? 0.5 : 1 }}>
      <OwcTooltip anchor="tv-mode-toggle" placement="top">
        {isTvMode ? "Disable TV mode" : "Enable TV mode"}
      </OwcTooltip>
      <IconButton
        id="tv-mode-toggle"
        aria-label="Toggle TV mode"
        title={isTvMode ? "Disable TV mode" : "Enable TV mode"}
        onClick={() => !disabled && dispatch(setTvMode(!isTvMode))}
        size="md"
        sx={{
            p: 0.5,
            cursor: 'pointer',
        }}
        disabled={disabled}
      >
          <OwcIcon
              name={isTvMode ? "full_screen_exit" : "full_screen"}
              type="filled"
              style={{ fontSize: 26, cursor: 'pointer', color: "var(--one-color-neutral-100)" }}
          />
      </IconButton>
    </div>
  );
};

export default TvModeToggle;
